<div id="assets-header">
  <h2 >Anhänge <span style="font-size: 14px; font-weight: 400;">({{ticketSrv?.ticket?.attachments?.length || 0}})</span></h2>
  <app-assets-add></app-assets-add>
</div>

<section #content id="a-content" [class.dark]="isDarkmode" [class.light]="!isDarkmode">
  <section style="margin-bottom: 15px; position: relative;">
    <p class="no-content" *ngIf="ticketSrv.ticket?.attachments?.length == 0" style="margin: 0; padding: 15px 0">Keine Anhänge</p>
    <asset-item *ngFor="let am of ticketSrv?.ticket?.attachments" [attachment]="am" [canDelete]="canDelete"></asset-item>
  </section>
</section>
